module.exports = __webpack_public_path__ + "static/media/cash-for-cars-acacia.e54ddf89.jpg";